export default __webpack_public_path__ + "static/media/612.dd9a7478.png";